import Box from 'UIKit/Box/Box'
import { ICommonBonus } from 'config/types/bonus'
import { BoosterWagerBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import InstructionDetails from '../InstructionDetails'
import InfoSectionDetails from './InfoSectionDetails'
import BoosterBonusDetailsSection from './BoosterBonusDetailsSection'

interface SimpleBonusDetails {
  bonus: ICommonBonus
}

const SimpleBonusDetails: React.FC<SimpleBonusDetails> = ({ bonus }) => {
  return (
    <Box overflow="hidden">
      {bonus instanceof BoosterWagerBonus ? (
        <BoosterBonusDetailsSection bonus={bonus} />
      ) : (
        <InfoSectionDetails bonus={bonus} />
      )}
      <InstructionDetails bonus={bonus} mt="28px" />
    </Box>
  )
}

export default SimpleBonusDetails
